import * as t from "io-ts";
export class DetermineTypeHelper {
  // #region Public Static Methods (1)
  static getType(value) {
    try {
      if (t.number.is(value)) {
        return "number";
      } else if (t.boolean.is(value)) {
        return "boolean";
      } else if (t.array(t.unknown).is(value)) {
        return "array";
      } else if (t.record(t.string, t.unknown).is(value)) {
        return "object";
      } else if (value === null) {
        return "null";
      } else if (value === undefined) {
        return "undefined";
      } else if (t.string.is(value)) {
        if (value.toString().startsWith("JSON")) {
          return "json";
        } else {
          return "string";
        }
      } else {
        return "unknown";
      }
    } catch (err) {
      console.error("ERROR DETERMINE TYPE OF VALUE", err);
      throw err;
    }
  }
}